import React from "react";
import "./App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import HomePage from './components/HomePage';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <div className="App">
          <HashRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
            </Routes>
          </HashRouter>
        </div>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
